import { useEffect } from 'react'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import Select from 'react-select'
import Button from '../../shared/components/Button/Button'
import selectStyles from '../../shared/css/SelectStyle'

function ProductFilterModal({ filters, onChange, onClear, onClose, categoryOptions, providerOptions, clothOptions, sizeGridOptions }) {

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar produtos</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">

                    <div className="fm-section">
                        <span className="fm-label">Sexo</span>
                        <div className="fm-status-row">
                            {[
                                { value: 'all', label: 'Todos' },
                                { value: 'M', label: 'Masculino' },
                                { value: 'F', label: 'Feminino' },
                                { value: 'M&F', label: 'Masc. e Fem.' },
                            ].map(opt => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${filters.sex === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange('sex', opt.value)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Categoria</span>
                        <Select
                            isClearable
                            options={categoryOptions || []}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={(categoryOptions || []).find((o) => o.value === filters.category) || null}
                            onChange={(option) => onChange('category', option ? option.value : '')}
                            placeholder="Todas"
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Fornecedor</span>
                        <Select
                            isClearable
                            options={providerOptions || []}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={(providerOptions || []).find((o) => o.value === filters.provider) || null}
                            onChange={(option) => onChange('provider', option ? option.value : '')}
                            placeholder="Todos"
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Tecido</span>
                        <Select
                            isClearable
                            options={clothOptions || []}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={(clothOptions || []).find((o) => o.value === filters.cloth) || null}
                            onChange={(option) => onChange('cloth', option ? option.value : '')}
                            placeholder="Todos"
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Grade de tamanho</span>
                        <Select
                            isClearable
                            options={sizeGridOptions || []}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={(sizeGridOptions || []).find((o) => o.value === filters.sizeGrid) || null}
                            onChange={(option) => onChange('sizeGrid', option ? option.value : '')}
                            placeholder="Todas"
                        />
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ProductFilterModal
